import { render } from "./TradePermts.vue?vue&type=template&id=de7adeb8"
import script from "./TradePermts.vue?vue&type=script&lang=js"
export * from "./TradePermts.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__